import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QueueMessage } from "../typeDefs/queueManagement";

export interface ArgusState {
    clientId: string;
    clientSecret: string;
    environmentId: string;
    workspaceEnabled: boolean;
    loading: boolean;
    credsValid: boolean;
    logs: QueueMessage[];
    mostRecentRun: Date | null;
}

const initialState: ArgusState = {
    clientId: "",
    clientSecret: "",
    environmentId: "",
    workspaceEnabled: false,
    loading: false,
    credsValid: false,
    logs: [],
    mostRecentRun: null,
};

export const argusSlice = createSlice({
    name: "argus",
    initialState,
    reducers: {
        setClientId: (state, action: PayloadAction<string>) => {
            state.clientId = action.payload;
        },
        setClientSecret: (state, action: PayloadAction<string>) => {
            state.clientSecret = action.payload;
        },
        setEnvironmentId: (state, action: PayloadAction<string>) => {
            state.environmentId = action.payload;
        },
        setWorkspaceEnabled: (state, action: PayloadAction<boolean>) => {
            state.workspaceEnabled = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMessages: (state, action: PayloadAction<QueueMessage[]>) => {
            state.logs = action.payload;
        },
        setMostRecentRun: (state, action: PayloadAction<Date | null>) => {
            state.mostRecentRun = action.payload;
        },
        setCredsValid: (state, action: PayloadAction<boolean>) => {
            state.credsValid = action.payload;
        },
    },
});

export const {
    setClientId,
    setClientSecret,
    setEnvironmentId,
    setWorkspaceEnabled,
    setLoading,
    setMessages,
    setMostRecentRun,
    setCredsValid,
} = argusSlice.actions;

export default argusSlice.reducer;
